interface RandomSource {
  randomUUID?: () => string
  getRandomValues(array: Uint8Array): Uint8Array
}

export function newBrowserId(
  source: RandomSource | undefined = globalThis.crypto,
) {
  if (typeof source?.randomUUID === 'function') return source.randomUUID()
  if (source) {
    const bytes = source.getRandomValues(new Uint8Array(16))
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
      '',
    )
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}
